export default "__VITE_PUBLIC_ASSET__72efccd6__"